
//BadgeArtBuilder Class & IconLibrary Class (for icons8)
//Dependent on fabric.js and jQuery


var IconLibrary = function(options){
    var oThis = this;
    this.defaults = {
        $iconsWrapper: $("#icons"),
        $categoriesList: $("#categories"),
        $termInput: $("#term"),
        $termButton: $("#searchIcons"),
        $platformInput: $("#platform"),
        $more: $("#moreIcons"),
        sIconsAPIbase: "https://api.icons8.com/api/iconsets/",
        nAmount: 55,
        sSpinner: '<div class="spinner spinner--pulsing"><div class="spinner-ring"></div></div>'
    }
    this.options = $.extend({}, this.defaults, options);
    this.oStack = new MessageStack();
    this.nPages = 0;
    this.sCategory = "";
    this.sTerm = "";
    this.sPlatform = "";
    this.sOperation = "";
    this.bAppend = false;
    this.oParams = {};
    this.sToken = "37f25a89cc3a269cd23aa9560f256f58991814f7";
    this.sLocalBase = (mantl.ENVIRON.DEBUG != undefined && mantl.ENVIRON.DEBUG == true) ? mantl.s3.dev + "mantlicons" : mantl.s3.prod + "mantlicons";
    //init
    this.setup();
}

IconLibrary.prototype.setup = function() {
    var oThis = this;
    oThis.getCategories();
    oThis.options.$more.hide().click(function(){
        oThis.loadMore();
    });

    oThis.options.$platformInput.change(function(){
        oThis.sPlatform = $(this).val();
    });

    oThis.options.$termInput.change(function(){
        oThis.sTerm = $(this).val();
    });

    oThis.options.$termInput.on('keypress', function(e) {
        oThis.resetPaging();
        var code = e.which;
        if (code === 13) {
            e.preventDefault();
            $(this).trigger("change");
            oThis.searchIcons();
        }
    });

    oThis.options.$termButton.click(function(){
        oThis.resetPaging();
        oThis.searchIcons();
    });

    oThis.options.$categoriesList.on("click",".collection-item",function(){
        oThis.resetPaging();
        var bIsLatest = $(this).is("[data-api=latest]");
        if(bIsLatest){
            oThis.getLatestIcons();
        } else {
            oThis.sCategory = $(this).attr("data-category");
            oThis.getCategoryIcons();
        }
        oThis.options.$termInput.val("");
        $(".collection-item",oThis.options.$categoriesList).removeClass("is-active");
        $(this).addClass("is-active");
    });
}

IconLibrary.prototype.callAPI = function(onSuccess) {
    var oThis = this;
    if(oThis.sOperation != "categories"){ oThis.showSpinner(); } //note to self, hardcoded, gross :P
    oThis.oParams['auth-id'] = oThis.sToken;
    $.ajax({
        url: oThis.options.sIconsAPIbase + oThis.sOperation,
        dataType: 'xml',
        data: oThis.oParams,
        error: function() {
            //message stack
        },
        success: function(data) {
            //console.log(data);
            onSuccess(data);
        },
        type: 'GET'
    });
}

IconLibrary.prototype.showSpinner = function() {
    var oThis = this;
    if(!oThis.bAppend) {
        oThis.options.$iconsWrapper.empty();
    }
    oThis.options.$iconsWrapper.append(oThis.options.sSpinner);
}

IconLibrary.prototype.removeSpinner = function() {
    var oThis = this;
    $(".spinner",oThis.$iconsWrapper).remove();
}

IconLibrary.prototype.resetPaging = function() {
    var oThis = this;
    oThis.nPages = 0;
    oThis.nOffset = 0;
    oThis.bAppend = false;
}

IconLibrary.prototype.insertIcons = function(data) {
    var oThis = this;
    //console.log("insert new icons");
    oThis.removeSpinner();
    if(!oThis.bAppend) {
        oThis.options.$iconsWrapper.empty();
    }

    var nCount = $(data).find("icon").length;
    if(nCount < oThis.options.nAmount) {
        oThis.options.$more.hide();
    } else {
        oThis.options.$more.show();
    }

    $(data).find("icon").each(function(){
        var created = new Date($(this).attr('created'));
        var cutoff = new Date(2016,10,23);
        //console.log(created > cutoff, created < cutoff);
        if(created < cutoff){
            var nName = $(this).attr('name');
            var $xmlSVG = $(this).find("vector > svg[format=editable]");
            var sDataURI = $(this).find("> svg").text();
            var $img = $("<img />");
            //data:image/png;base64,
            $img.attr({
                width: '48px',
                height: '48px',
                'data-svg': getSubPath($xmlSVG.attr('link'),5),
                src: "data:image/svg+xml;base64," + sDataURI,
                alt: nName,
                title: nName
            });
            oThis.options.$iconsWrapper.append($img);
        }
    });
}

IconLibrary.prototype.loadMore = function() {
    var oThis = this;
    //console.log("insert new icons");
    oThis.bAppend = true;
    oThis.nPages += 1;
    oThis.oParams.offset = oThis.nPages * oThis.options.nAmount;
    oThis.callAPI(function(data){
        oThis.insertIcons(data);
    });
}

IconLibrary.prototype.getCategories = function() {
    var oThis = this;
    //console.log("getCategories");
    oThis.sOperation = "categories";
    oThis.oParams = {};
    oThis.callAPI( function(data){
        $(data).find("categories category").each(function(){
            var $category = $("<button />");
            var nName = $(this).attr('name');
            $category.attr({
                'type': "button",
                'data-category' : nName,
                'data-api' : "cateogry",
                'class' : 'collection-item button--flat'
            }).text($(this).attr('name'));
            oThis.options.$categoriesList.append($category);
        });
    });
}

IconLibrary.prototype.getCategoryIcons = function(nCategory) {
    var oThis = this;
    //console.log("getCategoryIcons");
    oThis.sOperation = "category";
    oThis.oParams = {
        category: oThis.sCategory,
        amount: oThis.options.nAmount,
        offset: oThis.nOffset,
        platform: oThis.sPlatform
    };
    oThis.callAPI(function(data){
        oThis.insertIcons(data);
    });
}

IconLibrary.prototype.getLatestIcons = function(nCategory) {
    var oThis = this;
    //console.log("getLatestIcons");
    oThis.sOperation = "latest";
    oThis.oParams = {
        amount: oThis.options.nAmount,
        offset: oThis.nOffset,
        platform: oThis.sPlatform
    };
    oThis.callAPI(function(data){
        oThis.insertIcons(data);
    });
}

IconLibrary.prototype.searchIcons = function() {
    var oThis = this;
    //console.log("searchIcons");
    if(oThis.sTerm.length == 0) {
        alert("Please enter a search term.");
    } else {
        oThis.sOperation = "search";
        oThis.oParams = {
            amount: oThis.options.nAmount,
            offset: oThis.nOffset,
            platform: oThis.sPlatform,
            term: oThis.sTerm
        };
        oThis.callAPI(function(data){
            oThis.insertIcons(data);
        });
    }

}



var BadgeArtBuilder = function(options){
    if (!fabric) { throw new Error('fabric.js required. Please load before using BadgeArtBuilder.'); }
    var oThis = this;

    oThis.defaults = {
        canvasID: 'bbc',
        config_data: "#config_data",
        uri_data: "#uri_data"
    }
    oThis.settings = $.extend( {}, oThis.defaults, options );

    this.canvas = new fabric.Canvas(oThis.settings.canvasID);
    this.canvas.preserveObjectStacking = true;
    this.$wrapper = $("#"+oThis.settings.canvasID).closest(".badgebuilder");
    this.$color = this.$wrapper.find(".badgebuilder-color");
    this.$opacity = this.$wrapper.find(".badgebuilder-opacity");
    this.sLocalBase = (mantl.ENVIRON.DEBUG != undefined && mantl.ENVIRON.DEBUG == true) ? mantl.s3.dev + "mantlicons" : mantl.s3.prod + "mantlicons";

    //Bind UI
    this.$wrapper.on("click",".badgebuilder-art-thumbnails img",function(){
        oThis.addArt(this);
    });
    this.$wrapper.find(".badgebuilder-up").click(function(){
        oThis.bringForward();
    });
    this.$wrapper.find(".badgebuilder-down").click(function(){
        oThis.sendBackwards();
    });
    this.$wrapper.find(".badgebuilder-remove").click(function(){
        oThis.removeActiveObject();
    });
    this.$wrapper.find(".badgebuilder-addtext").click(function(){
        var text = $(".badgebuilder-text").val();
        oThis.addText(text);
        //$(".badgebuilder-text").val("");
    });
    this.$color.on('change',function(){
        oThis.applyTint();
    });
    this.$opacity.on('change',function(){
        oThis.applyOpacity();
    });

    //Load data if it's there
    if( $(oThis.settings.config_data).val().length > 0 && $(oThis.settings.config_data).val() != "null" && $(oThis.settings.config_data).val() != "None"){
        oThis.loadJSON();
    }

    //Bind fabric events
    //we bind at the end because they will fire if config data is loaded
    oThis.bindFabricEvents();

}

BadgeArtBuilder.prototype.applyTint = function(sColor) {
    var oThis = this;
    var sColor = sColor || oThis.$color.val();
    sColor = "#" + sColor;
    var object = oThis.canvas.getActiveObject();
    if (object != undefined) {
        if (object.filters != undefined) {
            //image
            var filter = new fabric.Image.filters.Tint({
                color: sColor
            });
            object.filters[0] = filter;
            object.applyFilters(oThis.canvas.renderAll.bind(oThis.canvas));
        } else {
            //svg
            if(object.get('type') == 'group'){
                object.getObjects().forEach(function(childObject) {
                    childObject.set("fill",sColor);
                });
            } else {
                object.set("fill",sColor);
            }
        }
        //re-render
        oThis.canvas.renderAll();
    }
}

BadgeArtBuilder.prototype.applyOpacity = function(nOpacity) {
    var oThis = this;
    var nOpacity = nOpacity || parseInt(oThis.$opacity.val())/100; //opacity is 0.0 to 1.0, slider is 0 to 100
    var object = oThis.canvas.getActiveObject();
    if (object != undefined) {
        if (object.filters != undefined) {
            //image
            var filter = new fabric.Image.filters.Tint({
                opacity: nOpacity
            });
            object.filters[0] = filter;
            object.applyFilters(oThis.canvas.renderAll.bind(oThis.canvas));
        } else {
            //svg
            object.set("opacity",nOpacity);
        }
        //re-render
        oThis.canvas.renderAll();
    }
}

BadgeArtBuilder.prototype.bringForward = function() {
    var oThis = this;
    var object = oThis.canvas.getActiveObject();
    if (object != undefined) {
        object.bringForward();
    }
}

BadgeArtBuilder.prototype.sendBackwards = function() {
    var oThis = this;
    var object = oThis.canvas.getActiveObject();

    if (object != undefined) {
        object.sendBackwards();
    }

}

BadgeArtBuilder.prototype.removeActiveObject = function() {
    var oThis = this;
    oThis.canvas.remove(oThis.canvas.getActiveObject());

}

BadgeArtBuilder.prototype.handleObjectSelection = function(target) {
    var oThis = this;
    oThis.getActiveStyle();
    target.transparentCorners = false;
    if(target.text){

        $(".badgebuilder-text").val(target.text).on("keyup",function(){
            target.set('text', $(".badgebuilder-text").val() );
            target.saveState();
            oThis.canvas.renderAll();
        });
    }

}

BadgeArtBuilder.prototype.bindFabricEvents = function() {
    var oThis = this;

    oThis.canvas.on('object:added', function(options) {
        //console.log('an object was added! ', options);
        if (options.target) {
            oThis.canvas.setActiveObject(options.target);
            options.target.center();
            options.target.setCoords(); //must do this to keep the object selectable, as Fabric by design (weird) doesn't update them on centering or scaling
        }
    });

    oThis.canvas.on('selection:created', function(options) {
        // console.log('an object was selected! ', options);
        if (options.target) {
            oThis.handleObjectSelection(options.target);
        }
    });

    oThis.canvas.on('selection:updated', function(options) {
        // console.log('A selection was updated.', options);
        if (options.target) {
            oThis.handleObjectSelection(options.target);
        }
    });

    oThis.canvas.on('selection:cleared', function(options) {
        $(".badgebuilder-text").off("keyup").val("");
    });

    oThis.canvas.on('object:modified', function(options) {
        if (options.target) {
            //console.log('an object was modified! ', options.target);
        }
    });

    oThis.canvas.on('object:removed', function(options) {
        if (options.target) {
            //console.log('an object was removed! ', options.target);
        }
    });
}

BadgeArtBuilder.prototype.addArt = function(art) {
    var oThis = this;
    var isShape = $(art).is(".badgebuilder-shape");
    var src = $(art).attr('data-svg');
    src = oThis.sLocalBase + src;

    if( BadgeArtBuilder.Utils.isSVG(src) ){
        //console.log("is svg");
        BadgeArtBuilder.Utils.loadSVG(src, function(svg) {
            oThis.canvas.add(svg);
            if(!isShape){
                svg.set({ scaleX: 3, scaleY: 3, }).center().setCoords();
            }
        });
    } else {
        //console.log("load from URL");
        BadgeArtBuilder.Utils.imageFromURL(src, function(img) {
            //console.log(img);
            oThis.canvas.add(img);
        });
    }

    var object = oThis.canvas.getActiveObject();
    if (!object) {
        return '';
    }
}

BadgeArtBuilder.prototype.addText = function(sText) {
    var oThis = this;
    var sText = sText || "";
    var oText = new fabric.Text(sText, {
        fontFamily: 'Lato',
        fontWeight: 'Bold',
        fontSize: 28,
        width: 400,
        textAlign: "center"
    });
    oThis.canvas.add(oText);
}

BadgeArtBuilder.prototype.getActiveStyle = function() {
    var oThis = this;
    var object = oThis.canvas.getActiveObject();
    if (object != undefined && oThis.$color[0].jscolor != undefined) {
        var sColor,
            nOpacity,
            sColor;

        if(object.getSelectionStyles && object.isEditing) {
            sColor = object.getSelectionStyles()['fill'] || '';
            nOpacity = object.getSelectionStyles()['opacity'] * 100;
        } else {
            if(object.get('type') == 'group'){
                sColor = object.getObjects()[0]['fill'] || '';
            } else {
                sColor = object['fill'] || '';
            }

            nOpacity = object['opacity']*100;
        }
        //set picker with active color
        var sColor = new fabric.Color(sColor).toHex();
        oThis.$color[0].jscolor.fromString(sColor);
        oThis.$opacity.val(nOpacity);
    }
}


BadgeArtBuilder.prototype.savePNG = function() {
    var oThis = this;
    //console.log("save png");
    oThis.canvas.discardActiveObject().renderAll();
    if (!fabric.Canvas.supports('toDataURL')) {
        alertify.warning("This browser doesn't have the ability to convert your canvas into an image. You will have to upload your own artwork.");
    } else {
        //window.open(oThis.canvas.toDataURL('png'));
        var dataURI = oThis.canvas.toDataURL('png');
        $(oThis.settings.uri_data).val( dataURI );
    }
}

BadgeArtBuilder.prototype.saveJSON = function() {
    var oThis = this;
    oThis.canvas.discardActiveObject().renderAll();
    // var json = oThis.canvas.toJSON();
    var json = JSON.stringify(oThis.canvas);
    //console.log(json);
    $(oThis.settings.config_data).val(json);
}

BadgeArtBuilder.prototype.loadJSON = function(json) {
    var oThis = this;
    var json = json || $(oThis.settings.config_data).val();
    json = cleanJSONString(json);
    json = JSON.parse(json);
    oThis.canvas.loadFromJSON(json, function(){
        oThis.canvas.discardActiveObject().renderAll();
    });
}

BadgeArtBuilder.Utils = {
    isDataURL: function isDataURL(url) {
        return url.trim().indexOf('data:image') === 0
    },

    isSVG: function isSVG(url) {
        return url.trim().indexOf('.svg') != -1
    },

    imageFromURL: function imageFromURL(url, callback) {
        if (!BadgeArtBuilder.Utils.isDataURL(url)) {
            return fabric.Image.fromURL(url, callback)
        }

        var img = document.createElement('img');
        /*img.height = 460;
        img.width = 460;*/
        /*img.style.height = "480px";
        img.style.width = "480px";*/
        img.src = url;
        img.crossOrigin = "Anonymous";
        img.onload = function () {
            img.onload = null;
            return callback(new fabric.Image(img));
        }
    },

    loadSVG: function loadSVG(path, callback) {
        fabric.loadSVGFromURL(path, function (objects, options) {
            return callback(new fabric.Group(objects))
        })
    }
};
